import React from "react";
import './SearchBar.css';

class SearchBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      term: '',
      location: '',
      sortBy: 'best_match'
    };

    this.handleTermChange = this.handleTermChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);

    this.sortByOptions =  {
      'Best Match': 'best_match',
      'Highest Rated': 'rating',
      'Most Reviewed': 'review_count'
    };
  }

  getSortByClass(sortByOption) {
    if (sortByOption === this.state.sortBy) {
      return 'active';
    }
    return '';
  }

  handleSortByChange(sortByOption) {
    this.setState({ sortBy: sortByOption });
  }

  handleTermChange(event) {
    this.setState({ term: event.target.value });
  }

  handleLocationChange(event) {
    this.setState({ location: event.target.value });
  }

  handleSearch(event) {
    this.props.searchYelp(this.state.term, this.state.location, this.state.sortBy);
    event.preventDefault();
  }
  renderSortByOptions() {
    return Object.keys(this.sortByOptions).map(sortByOption => {
      let sortByOptionValue = this.sortByOptions[sortByOption];
      return <li key={sortByOptionValue} className={this.getSortByClass(sortByOptionValue)} onClick={this.handleSortByChange.bind(this, sortByOptionValue)}>{sortByOption}</li>
    });
  }

  render() {
    return (
      <div className="SearchBar">
        <div className="SearchBar-sort-options">
          <ul>
            { this.renderSortByOptions() }
          </ul>
        </div>

        {/* set the options for user to prevent unexpected keywords */}
        <div className="SearchBar-fields">
          <select required onChange={this.handleTermChange}>
            <option value="" disabled selected hidden>Services Around...</option>
            <option value="restaurant">Restaurant</option>
            <option value="delivery">Delivery</option>
            <option value="plumber">Plumber</option>
            <option value="auto repair">Auto Repair</option>
          </select>

          {/* set the options in accordance with the realties' location */}
          <select required onChange={this.handleLocationChange}>
            <option value="" disabled selected hidden>Choose City</option>
            <option value="brampton ontario">Brampton, ON</option>
            <option value="brandon manitoba">Brandon, MB</option>
            <option value="ottawa Ontario">Ottawa, ON</option>
            <option value="pincourt quebec">Pincourt, QC</option>
            <option value="regina Saskatchewan">Regina. SK</option>
            <option value="vancouver British Columbia">Vancouver, BC</option>
            <option value="winnipeg manitoba">Winnipeg, MB</option>
          </select>

        </div>
        <div className="SearchBar-submit">
          <a href="www.#.com" onClick={this.handleSearch}>Let's Go</a>
        </div>
      </div>
    );
  }
}

export default SearchBar;